import { get } from '$fetch'

/**
* 获取车辆历史成交数据
* @param {String} cid 车源id
* @returns
*/

export const getSoldCars = params => get('/lurker/v1/detail/sold/cars', params, { isFormData: false, isAutoMsg: false })
